import { deprecated } from "@gr-common/head/tools";

window.AS ||= {};
window.AS.RUM ||= {
  get sendCustomRequest() {
    deprecated("AS.RUM.sendCustomRequest", "use otto.apm.sendCustomError");
    return otto.apm.sendCustomError;
  },
};
